import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGet } from "mocksdata/operatingwalletlog";
import { onGetTrans } from "mocksdata/tokentranssactionslog";
/*Change Get Api here*/
const getApiOperatingwalletlog = async (query) => {
  onGet(query);
  return axiosInstance({
    method: "get",
    url: "/operator-transactions",
    params: { ...query, transfer: false },
  }).then(handleResponse);
};
const getApiTokenTranssactionsLog = async (query) => {
  onGetTrans(query);
  return axiosInstance({
    method: "get",
    url: "/operator-transactions",
    params: { ...query, transfer: true },
  }).then(handleResponse);
};

const getOWHistoryLog = async (query) => {
  return axiosInstance({
    method: "get",
    url: "/ow-active-status-histories",
    params: query,
  }).then(handleResponse);
};

export { getApiOperatingwalletlog, getApiTokenTranssactionsLog, getOWHistoryLog };
